import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import dayjs from 'dayjs';
import moment from 'moment';
import { env } from "../../../env";
import axios from "axios";
import Swal from "sweetalert2";
import DatePickerComponent from "../Field/DatePickerComponent";
import CalendarTimePicker from "./CalendarTimePicker";
import { useParams } from "react-router-dom";

const EventCompleteModal = ({ eventDetails, setShowCompleteViewModal, sendEventChildFromData }) => {
    const { t } = useTranslation();
    const {id} = useParams();
    const [isLoad, setIsLoad] = useState(false);
    const [ipData, setIpData] = useState({});
    const [inputs, setInputs] = useState({
        id: 0,
        fromTime: dayjs().format('YYYY-MM-DDTHH:mm:ss'),
        toTime: dayjs().add(30, 'minute').format('YYYY-MM-DDTHH:mm:ss'),
        followupDate: dayjs().format("YYYY-MM-DD"),
        comment: ""
    });

    useEffect(() => {
        const fetchData = async () => {
            await getIpJson();
        };
    
        fetchData();
    }, []);
    useEffect(() => {
        setInputs((prev) => ({
            ...prev,
            id: eventDetails.id,
        }));
    }, [eventDetails]);

    const getIpJson = async () => {
        axios.get("https://ipapi.co/json/", { headers : {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
        }})
        .then((response) => {
            setIpData(response.data);
        }).catch((error) => {
            console.log(error);
        });
    };
    const handleShowCompleteModal = (e) => {
        e.preventDefault();
        setShowCompleteViewModal()
    };
    const handleDateDataFromChild = (data) => {
        setInputs((prev) => ({
            ...prev,
            followupDate: moment(data.date, "DD/MM/YYYY").format("YYYY-MM-DD")
        }));
    };
    const handleTimeDataFromChild = (data) => {
        setInputs((prev) => ({
            ...prev,
            fromTime: data.fromTime,
            toTime: data.toTime,
        }));
    };
    const handleChange = (e) => {
        setInputs((prev) => ({
            ...prev,
            comment: e.target.value
        }));
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        Swal.fire({
            title: `${ t("are you sure")}?`,
            text: `${ t("you want to complete this appointment")}?`,
            width: 400,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: `${ t("yes")}!`,
            cancelButtonText: `${ t("cancel")}!`
        }).then((result) => {
            if (result.isConfirmed) {
                setIsLoad(true);
                const baseUrl = env.REACT_APP_API_URL;
                const token = localStorage.getItem('token');      
                const requestData = {
                    "appointmentid": inputs.id,
                    "comment": inputs.comment,
                    "starttime":  moment(inputs.fromTime).format("HH:mm:00"),
                    "endtime":  moment(inputs.toTime).format("HH:mm:00"),
                    "followUpDate": inputs.followupDate,
                    "latgps": ipData.latitude,
                    "longgps": ipData.longitude
                }

                console.log(requestData);

                axios.post(baseUrl+"/api/ClientAppointments/CompleteClientAppointmentByID", requestData, {
                    headers : {
                        "Accept" : "Application/json",
                        "Content-Type" : "Application/json",
                        "Authorization" : `Bearer ${token}`,
                    }
                }).then((response) => {
                    console.log(response);
                    if(response.data.success === "1") {
                        sendEventChildFromData("complete");
                    }
                }).catch((error) => {
                    console.log(error);
                    setIsLoad(false);
                    if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                        localStorage.removeItem("token");
                        localStorage.removeItem("userInfo");
                        window.location.reload();
                    }
                });
            }
        });

    }

    return (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex justify-center items-end sm:items-center z-50">
            <form onSubmit={handleSubmit}>
                <div className="bg-white rounded-t-lg sm:rounded-lg shadow-lg w-[34rem] p-2.5 sm:p-6 space-y-2 sm:space-y-4">                
                    <div className="flex justify-between items-center">
                        <div className='flex items-center space-x-2'>
                            <h3 className="text-lg font-semibold capitalize">
                                { t('complete appointment')}
                            </h3>
                        </div>
                        <button type="button" onClick={(e) => (!isLoad && handleShowCompleteModal(e))} className="text-gray-500 hover:text-gray-700">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"/>
                            </svg>
                        </button>
                    </div>
                    <div className='space-y-2'>
                        <div className='grid grid-cols-2 gap-2'>
                            <div className="space-y-1">
                                <div className='flex items-start space-x-2'>
                                    <label className='text-xs sm:text-sm capitalize text-light-700'>{t('appointment time')}</label>
                                </div>
                                <div className='flex justify-between text-xs sm:text-base bg-white border border-background-normal rounded-md px-4 py-2.5'>
                                    <CalendarTimePicker startDateTime={inputs.fromTime} endDateTime={inputs.toTime} sendTimeDataFromChild={handleTimeDataFromChild} />
                                </div>
                            </div>
                            <div className="space-y-1">
                                <div className='flex items-start space-x-2'>
                                    <label className='text-xs sm:text-sm capitalize text-light-700'>{t('follow up date')} <span className="text-xs">({ t('if any')})</span></label>
                                </div>
                                <div className='bg-white border border-background-normal rounded-md text-sm sm:text-base'>
                                    <DatePickerComponent setDataFromChild={handleDateDataFromChild} startDate={dayjs()} dateInput={dayjs()} name={'date'}/>
                                </div>
                            </div>
                        </div>
                        <textarea value={inputs.comment} onChange={handleChange} className="bg-white border border-background-normal rounded-md px-4 py-2 w-full relative flex items-start focus:outline-none" rows={5} columns={10} placeholder={ t("write comments here...")}></textarea>
                    </div>
                    <div className="flex justify-between items-center text-sm sm:text-base">
                        <button type="button" onClick={(e) => (!isLoad && handleShowCompleteModal(e))} className="px-4 py-2 bg-white text-gray-dark4 capitalize font-medium border-2 border-background-normal rounded-lg">
                            { t('close')}
                        </button>
                        <button type={isLoad ? "button" : "submit"} className={(isLoad ? "cursor-not-allowed" : "cursor-pointer") + " px-4 py-2 bg-blue-normal text-white rounded-lg capitalize"}>
                            {isLoad ? (t('Please wait')+'...') : t('complete appointment')}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default EventCompleteModal;
